module.exports = __webpack_public_path__ + "static/media/w_cloudy_rainy.8a1fbe34.svg";